import { Component, OnInit } from '@angular/core';
import { FspPremissesOwnerGridDataService } from './fsp-premisses-owner-grid-data.service';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { filter, takeWhile, tap } from 'rxjs';
import {
  fspOwnersGridColumns,
  getFspOwnersGridToolbarItems,
} from '../../fsp-owners-grid/fsp-owners-grid-model';
import { FspPremissesGridDataService } from '../fsp-premisses-grid/fsp-premisses-grid-data.service';
import { GkKendoGridComponent } from '../../../../gk-kendo';
import { WladajacyResponseDto } from '../../../../gk-map/models';

@Component({
  selector: 'app-fsp-premisses-owners-grid',
  templateUrl:
    '../../../../gk-kendo/gk-kendo-grid/gk-kendo-grid.component.html',
  standalone: false,
})
export class FspPremissesOwnerGridComponent
  extends GkKendoGridComponent<WladajacyResponseDto>
  implements OnInit
{
  constructor(
    private fspBuildingsOwnerGridDataService: FspPremissesOwnerGridDataService,
    private fspPremissesGridDataService: FspPremissesGridDataService,
  ) {
    super(fspBuildingsOwnerGridDataService);
  }

  override topGridToolbarItems = getFspOwnersGridToolbarItems();
  override columns = fspOwnersGridColumns;
  override selectable: SelectableSettings = {
    enabled: true,
    mode: 'single',
  };
  override sortable = true;

  ngOnInit(): void {
    this.subscribeBuildingsGridSelected();
  }

  subscribeBuildingsGridSelected(): void {
    this.fspPremissesGridDataService.$selection
      .pipe(
        takeWhile(() => this.isAlive),
        tap(() => {
          this.fspBuildingsOwnerGridDataService.clearGridData();
        }),
        filter(Boolean),
      )
      .subscribe((selection) => {
        this.fspBuildingsOwnerGridDataService.next({
          data: selection.selectedItems[0].Wladajacy,
          total: selection.selectedItems[0].Wladajacy.length,
        });
      });
  }
}
